import React, { useState, useEffect } from 'react';
import PageHeader from '../../../components/PageHeader';
import { DoorbaseTile, DoorbaseTileGrid } from '../../../components/DoorbaseTile';
import { useNavigate } from 'react-router-dom';
import { apiGet } from '../../../utils/api';

function OperationsMainLanding() {
  const navigate = useNavigate();
  const [modules, setModules] = useState({ sales_orders: false, door_configurator: false });

  useEffect(() => {
    // Fetch module settings
    apiGet('/api/company-settings')
      .then(data => {
        if (data && data.id) {
          setModules({
            sales_orders: data.module_sales_orders || false,
            door_configurator: data.module_door_configurator || false
          });
        }
      })
      .catch(err => console.error('Error fetching modules:', err));
  }, []);

  const navItems = [
    { path: '/ops/jobs', label: 'Jobs', icon: '📋', description: 'Job management and tracking' },
    { path: '/ops/quotes', label: 'Quotes', icon: '📄', description: 'Customer quotes and estimates' },
    { path: '/ops/purchase-orders', label: 'Purchase Orders', icon: '🛒', description: 'Order from suppliers' },
    { path: '/ops/engineer-app', label: 'Engineer app', icon: '📱', description: 'Further work and phone tiles' },
  ];

  // Add Sales Orders if module is enabled
  if (modules.sales_orders) {
    navItems.push({ 
      path: '/ops/sales-orders', 
      label: 'Sales Orders', 
      icon: '📦', 
      description: 'Product sales without installation' 
    });
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader 
        title="Operations"
        subtitle="Job Management, Quotes & Equipment Tracking"
        sticky
      />

      <main className="max-w-6xl mx-auto px-6 py-8">
        <div className="bg-gray-300 rounded-lg shadow p-6 mx-auto" style={{ width: 'fit-content', maxWidth: '1200px' }}>
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Quick Access</h2>
          <DoorbaseTileGrid columns={4}>
            {navItems.map((item) => (
              <DoorbaseTile
                key={item.path}
                icon={item.icon}
                label={item.label}
                description={item.description}
                onClick={() => navigate(item.path)}
              />
            ))}
          </DoorbaseTileGrid>
        </div>
      </main>
    </div>
  );
}

export default OperationsMainLanding;
